import React, { useState } from "react";
import multify from "../assets/multify.webp";
import MenuArrow from "../assets/Line .svg";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav className="fixed top-0 w-full z-50 bg-[#050122]/50 backdrop-blur-[5px] rounded-b-3xl overflow-hidden header">
      <div className="">
        <div className="container mx-auto flex items-center justify-between h-[70px] header px-[10px] sm:px-0">
          <Link to="/" className="text-white text-2xl font-bold">
            <img src={multify} alt="Logo" width={120} />
          </Link>

          {/* Toggle Button */}
          <button
            className="text-white focus:outline-none"
            onClick={toggleMenu}
          >
            {isMenuOpen ? (
              // Close Icon
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            ) : (
              // Hamburger Menu Icon
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16m-7 6h7"
                />
              </svg>
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        <div className={`headerBG ${isMenuOpen ? "block" : "hidden"}`}>
          <div className="menuContainer">
            {[
              ["HOME", "/"],
              ["ABOUT", "/about"],
              ["SERVICES", "/services"],
              ["CAREER", "/career"],
              ["CONTACT", "/contact"],
            ].map(([name, path], index) => (
              <Link
                key={name}
                to={path}
                className="topMenu block text-gray-300 hover:text-white transition-colors duration-300 py-2"
                onClick={closeMenu} // Close menu on item click
              >
                <div className="flex flex-col justify-between h-[65px] items-end">
                  <span>{`0${index + 1}`}</span>
                  <img src={MenuArrow} alt="menu-arrow" />
                </div>
                {name}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
